module.exports = __webpack_public_path__ + "static/media/TIOA.a8523065.jpg";